import React from 'react';
import { connect } from 'react-redux';
import { DBTextAreaObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class SpecTestsRLCommentPanel extends React.Component {

    render() {

        return (
            <div key={this.props.panel.MOPNO} className={styles.textarea_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flagged} mopno={this.props.panel.MOPNO} flagText={this.props.header + ' - ' + this.props.panel.MOPLABEL} />
                <span className={styles.spacer} />
                <label className={styles.textarea_label}>{this.props.panel.MOPLABEL}</label>
                <DBTextAreaObjective
                    field={this.props.panel.MOPCOLUMNPREFIX + 'R'}
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESPECTESTS'
                    entityKeyColumn='TSNO'
                    entityKeyValue={this.props.tsno}
                    className={styles.rl_comment}
                />
                <span className={styles.c} />
                <DBTextAreaObjective
                    field={this.props.panel.MOPCOLUMNPREFIX + 'L'}
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESPECTESTS'
                    entityKeyColumn='TSNO'
                    entityKeyValue={this.props.tsno}
                    className={styles.rl_comment}
                />
            </div>
        );
    }

}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));
    let panel = state.entities.masterData.PTMASTEROBJECTIVEPANELS[ownprops.panelId];

    return {
        noteId: noteId,
        tsno: tsno,
        flagged: state.entities.notes.PTOBJECTIVESPECTESTS[tsno][panel.MOPCOLUMNPREFIX + 'R']
            || state.entities.notes.PTOBJECTIVESPECTESTS[tsno][panel.MOPCOLUMNPREFIX + 'L'] ? true : false,
        panel: panel
    };
}

const connectedSpecTestsRLCommentPanel = connect(mapStateToProps)(SpecTestsRLCommentPanel);
export { connectedSpecTestsRLCommentPanel as SpecTestsRLCommentPanel };


